import { IItem } from "../../../shared/model/types";

export interface ITeamFormState {
    name: string;
    tgAccounts: IItem[];
    coordinator: IItem | null;
    tgCuratorIds: Record<number, number[]>;
}

export const initialFormState: ITeamFormState = {
    name: '',
    tgAccounts: [],
    coordinator: null,
    tgCuratorIds: {},
}

export const toUniqueSorted = (ids: number[]) => Array.from(new Set(ids)).sort((a, b) => a - b)

export const TEAM_ACTION_UPDATE = 'TEAM_ACTION_UPDATE' as const
export const TEAM_ACTION_DELETE = 'TEAM_ACTION_DELETE' as const
